import { render, staticRenderFns } from "./Taxes.vue?vue&type=template&id=085f2b5c&"
import script from "./Taxes.vue?vue&type=script&lang=ts&"
export * from "./Taxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports